import { render, staticRenderFns } from "./abstract-table.vue?vue&type=template&id=4795cd2b"
import script from "./abstract-table.vue?vue&type=script&lang=js"
export * from "./abstract-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports